import { useEffect, useRef, useState } from 'react';
import { collection, limit, onSnapshot, query } from 'firebase/firestore';
import { db } from '../firebase/config';
import toast from 'react-hot-toast';

export function useFirestoreConnection() {
  const [connected, setConnected] = useState(true);
  // Suit la connexion réelle observée par Firestore (pas navigator.onLine,
  // qui peut rester "online" alors que Firestore n'arrive pas à joindre le
  // serveur — captive portal, pare-feu...) pour ne toaster qu'aux vraies
  // transitions plutôt qu'à chaque montage du hook.
  const previousRef = useRef(true);

  useEffect(() => {
    // Listener léger sur une collection vide pour détecter la connexion
    const q = query(collection(db, 'parametres'), limit(1));
    const unsub = onSnapshot(q,
      () => {
        if (!previousRef.current) toast.success('Connexion rétablie — données synchronisées');
        previousRef.current = true;
        setConnected(true);
      },
      () => {
        if (previousRef.current) toast.error('Connexion perdue — mode hors ligne', { duration: 5000 });
        previousRef.current = false;
        setConnected(false);
      }
    );
    return () => unsub();
  }, []);

  return connected;
}
